import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import Cookies from '../common/Cookies.js';
import axios from 'axios';
import TenantSelectionModal from '../components/TenantSelectionModal';

const SocialLoginCallback = ({ setLoggedIn }) => {
  const { token } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [alert, setAlert] = useState(null);

  // Agency tenant selection state
  const [agencyTenants, setAgencyTenants] = useState([]);
  const [agencyToken, setAgencyToken] = useState(null);
  const [showTenantModal, setShowTenantModal] = useState(false);
  const [tenantSelectLoading, setTenantSelectLoading] = useState(false);

  const completeLogin = (jwtToken) => {
    axios.defaults.headers.common['Authorization'] = `Bearer ${jwtToken}`;
    Cookies.setJwtToken(jwtToken);
    var tokenPayload = atob(jwtToken.split(".")[1]);
    var jsonToken = JSON.parse(tokenPayload);
    Cookies.setTenantId(jsonToken.tenantId);
    Cookies.setCookies('fname', jsonToken.firstName);
    Cookies.setCookies('lname', jsonToken.lastName);
    Cookies.setCookies('email', jsonToken.email);
    Cookies.setCookies('hasAgent', jsonToken.hasAgent);
    if (jsonToken.agencyId) {
      Cookies.setCookies('agencyId', jsonToken.agencyId);
    }
    setAlert({ severity: "success", message: `Welcome ${jsonToken.firstName} ${jsonToken.lastName}` });
    setLoggedIn(true);
    navigate('/Dashboard/true');
  };

  const handleTenantSelect = (tenantId) => {
    setTenantSelectLoading(true);
    axios.post("/login/select-tenant", null, { params: { token: agencyToken, tenantId } })
      .then((res) => {
        if (res.data && res.data.status === 'success') {
          setShowTenantModal(false);
          completeLogin(res.data.body);
        }
      })
      .catch(() => { })
      .finally(() => setTenantSelectLoading(false));
  };

  useEffect(() => {
    if (token == null || token.length === 0) return;

    const searchParams = new URLSearchParams(window.location.hash.split('?')[1] || '');
    const isAgency = searchParams.get('agency') === 'true';

    if (isAgency) {
      // Agency social login: token is a temp JWT, need to fetch tenants and let user pick
      setAgencyToken(token);
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      axios.get('/login/agency-tenants')
        .then(res => {
          if (res.data?.status === 'success' && Array.isArray(res.data.body)) {
            setAgencyTenants(res.data.body);
            setShowTenantModal(true);
          }
        })
        .catch(() => { });
    } else {
      completeLogin(token);
    }
  }, [token, navigate]);

  return (
    <div>
      {showTenantModal ? 'Please select a tenant to continue...' : 'Logging you in...'}
      <TenantSelectionModal
        open={showTenantModal}
        tenants={agencyTenants}
        onSelect={handleTenantSelect}
        loading={tenantSelectLoading}
      />
    </div>
  );
};

export default SocialLoginCallback;
